import * as React from 'react';
import { IconProps } from '../types';

const IcSecurity = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M12.481.043a.774.774 0 0 1 .617.053c3.157 1.454 6.313 2.903 9.47 4.357.282.124.498.406.488.722 0 1.416.005 2.836 0 4.257-.034 3.457-1.387 6.868-3.688 9.44a14.631 14.631 0 0 1-2.118 1.952l-4.018 3.013a.783.783 0 0 1-.961 0c-.885-.665-1.77-1.325-2.65-1.99-.866-.66-1.77-1.276-2.559-2.027-2.487-2.325-4.098-5.563-4.472-8.944a14.857 14.857 0 0 1-.09-1.727V5.18a.81.81 0 0 1 .473-.74C6.144 2.97 9.31 1.496 12.481.042ZM4.025 5.687V8.14c.005.813-.024 1.631.067 2.44.326 3.247 1.913 6.36 4.4 8.48.445.382.928.722 1.397 1.075.952.713 1.908 1.426 2.86 2.133 1.22-.903 2.444-1.807 3.659-2.72 2.74-2.11 4.591-5.343 4.979-8.782.115-.904.081-1.813.086-2.721V5.69a3543.994 3543.994 0 0 0-8.724-4.031C9.841 3.003 6.933 4.347 4.025 5.687Z" />
      <path d="M16.719 8.71a.749.749 0 0 1 .574-.24c.411.01.77.402.736.813a.767.767 0 0 1-.239.498c-1.827 1.827-3.654 3.649-5.476 5.476-.13.129-.254.277-.43.33-.187.057-.398.072-.58-.014-.148-.067-.243-.21-.358-.32l-3.18-3.181a.745.745 0 0 1-.24-.584.79.79 0 0 1 .732-.727.753.753 0 0 1 .555.215c.928.919 1.846 1.851 2.774 2.765 1.703-1.674 3.42-3.353 5.132-5.032Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcSecurity;
